import React from "react";

/* Official CompliAssure seal. The provider script uses document.write, so it is loaded
   inside an isolated frame rather than injected into the SPA document. */
const SEAL_SRC =
  "https://rapidscansecure.com/siteseal/siteseal.js?code=17,78DC7219A681C62ED37541100BC363D3BCF746FD";

const DOC = `<!doctype html><html><head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:transparent">
<script type='text/javascript' src='${SEAL_SRC}'><\/script>
</body></html>`;

export const SiteSeal = () => (
  <iframe
    title="CompliAssure Secured site seal"
    data-testid="compliassure-site-seal"
    srcDoc={DOC}
    sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
    scrolling="no"
    className="block h-[69px] w-[160px] border-0"
    loading="lazy"
  />
);

export default SiteSeal;
